import { FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { SummaryItem } from 'src/api/learningSessions/types';
import { getReviewTime } from '../getReviewTime';
import { GrowthFlower, WordStatus } from '../GrowthFlower';
import { ReviewPill } from '../ReviewPill';
import * as S from './styles';

const msgs = defineMessages({
  stillLearning: { id: 'blob_eos_still_learning', defaultMessage: 'Still learning' },
  markedAsKnown: { id: 'mywords_marker_IAKT' },
  justLearned: { id: 'eos_learn_scenarioSummary_fullyLearned' },
  reviewed: { id: 'blob_eos_reviewed', defaultMessage: 'Reviewed' },
} satisfies Record<WordStatus, unknown>);

const SHOWS_REVIEW_TIME: Record<WordStatus, boolean> = {
  stillLearning: false,
  markedAsKnown: false,
  justLearned: true,
  reviewed: true,
};

type WordGroupProps = {
  status: WordStatus;
  items: SummaryItem[];
};

export const WordGroup: FC<WordGroupProps> = ({ status, items }) => {
  const intl = useIntl();
  const title = intl.formatMessage(msgs[status]);

  return (
    <S.Card aria-label={title} data-testid={`blob-eos-group-${status}`}>
      <S.Header>
        <S.Title>{title}</S.Title>
        <S.Count>{items.length}</S.Count>
      </S.Header>
      <S.List>
        {items.map(({ learnableId, item, definition, growthLevel, nextReviewDate }) => {
          const reviewTime =
            SHOWS_REVIEW_TIME[status] && nextReviewDate ? getReviewTime(nextReviewDate) : null;

          return (
            <S.Row key={learnableId}>
              <S.Flower>
                <GrowthFlower status={status} growthLevel={growthLevel} />
              </S.Flower>
              <S.Words>
                <S.Target dir="auto">{item.value}</S.Target>
                <S.Source dir="auto">{definition.value}</S.Source>
              </S.Words>
              {reviewTime && <ReviewPill {...reviewTime} />}
            </S.Row>
          );
        })}
      </S.List>
    </S.Card>
  );
};
